import { fullName } from "../app/utils"

export default function InputSelect(props) { 

    const {id, label, options, onChange, currentValue} = props

    const optionElements = []

    if(props.peopleList) {
        optionElements.push(
            <option 
                key={"-1"} 
                value={"-1"}>
                {"Select"}
            </option>
        )
            
        options.forEach((person, index) => {
            let text = ""
            if(person.position) {
                text = `${fullName(person)},(${person.position})`
            } else {
                text = fullName(person)
            }

            optionElements.push(
                <option 
                    key={`select-option-${person.entityId}`} 
                    value={person.entityId}>
                    {text}
                </option>
            )
        })
    }

    return (
        <fieldset>
            <div className="ns-field-set fw-25">
                <label
                    className="ns-label" 
                    id={id + "-select-label"}
                    htmlFor={id + "-select-input"}>
                        {label}
                </label>
                <div className="select fw-20 inlineDisplay">
                    <select
                        style={{width: "20em"}}
                        id={id + "-select-input"}
                        name={id + "-select-input"}
                        value={currentValue}
                        onChange={onChange}>
                            {optionElements}
                    </select>
                </div>
            </div>
        </fieldset>
    )
}
